import { useParams } from "react-router-dom";

import { ItineraryPublicShareFeaturePage } from "..";

/** 无需登录的客户行程分享页。 */
export function ItineraryPublicSharePage() {
  const { token = "" } = useParams();
  return <ItineraryPublicShareFeaturePage token={token} />;
}
